/**

 * Formato MySQL DATETIME (UTC): 'YYYY-MM-DD HH:MM:SS'.

 * Evita ISO con T/Z que MySQL DATETIME rechaza (error visita_fin).

 * Preferir UTC igual que backend/toMysqlDatetime.

 */



function pad(n) {

  return String(n).padStart(2, '0');

}



function formatUtcMysqlDatetime(d) {

  return (

    `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ` +

    `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`

  );

}



/**

 * @param {Date|string|number|null|undefined} value

 * @returns {string|null}

 */

export function toMysqlDatetime(value) {

  if (value == null || value === '') return null;

  if (typeof value === 'number' && Number.isFinite(value)) {

    const ms = value < 1e12 ? value * 1000 : value;

    const d = new Date(ms);

    if (Number.isNaN(d.getTime())) return null;

    return formatUtcMysqlDatetime(d);

  }

  if (value instanceof Date) {

    if (Number.isNaN(value.getTime())) return null;

    return formatUtcMysqlDatetime(value);

  }

  const s = String(value).trim();

  if (!s || s === 'Invalid Date' || s === 'null' || s === 'undefined') return null;

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/.test(s)) {

    return s.slice(0, 19);

  }

  const d = new Date(s);

  if (Number.isNaN(d.getTime())) return null;

  return formatUtcMysqlDatetime(d);

}



/** Ahora en formato MySQL DATETIME (UTC). */

export function mysqlNow() {

  return formatUtcMysqlDatetime(new Date());

}


